export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/generateAsync.worker.a8c882a2.worker.js");
}
